import { mapState } from 'vuex'

export default {
  methods: {
    /**
     *  Api request to validate the emil
     * @param email
     * @returns {*}
     */
    requestValidateEmail (email) {
      return this.$_apiMixin_get('api/v2/validate/email/', { 'email[email]': email }, this.$_apiMixin_httpOptions)
    },
    /**
     * Api request to check if an email exist
     * @param email
     * @returns {*}
     */
    requestEmailExist (email) {
      return this.$_apiMixin_get('api/v2/email/exists/', { email })
    },
    /**
     * Api request to get the the matched location
     *
     * @param country
     * @param searchTerm
     * @returns {Promise<Array|{}|boolean> | * | PromiseObj | PromiseObj | Thenable<Array|{}|boolean> | Promise | Promise<any> | PromiseLike<Array | {} | boolean | never> | Promise<Array | {} | boolean | never>}
     */
    requestGetLocation (country, searchTerm, limit) {
      return this.$_apiMixin_get('api/location/search/', { country, searchTerm, limit })
        .then(data => {
          return data.locations
        })
    },
    /**
     * Api request to validate the username
     * @param username
     * @returns {*}
     */
    requestValidateUsername (username) {
      return this.$_apiMixin_get(`api/v2/validate/username/${username}/`)
    },
    /**
     * Api request to get the suggestion of possible usernams
     * @param username
     * @returns {*}
     */
    requestUsernameSuggestions (username) {
      return this.$_apiMixin_get(`api/suggestNickname/${username}/`)
    },
    /**
     * Get the link for the login to the old webpage
     * @returns {*}
     */
    requestLegacyLogin () {
      return this.$_apiMixin_get('api/v2/legacy-login/', {}, this.$_apiMixin_httpOptions)
    },
    /**
     * request to change the email
     * @param email
     * @returns {*}
     */
    requestEmailChange (email) {
      let body ={
        'emailChange[email][newEmail]': email,
        'emailChange[email][newEmailRepetition]': email,
      }

      body = this.$_apiMixin_addUtm(body, 'emailChange')

      return this.$_apiMixin_post('api/changeEmail/', body, this.$_apiMixin_httpOptions)
    },
    /**
     * api request to validate the registration code of the user
     * @param regCode
     * @returns {*}
     */
    requestValidateRegistrationCode (regCode) {
      return this.$_apiMixin_post('api/v2/validate/reg-code/', { regCode }, this.$_apiMixin_httpOptions)
    },
    /**
     * api request to register the user
     *
     * @param registration
     * @returns {*}
     */
    requestRegister (registration) {
      let body = {}
      for (const key in registration) {
        body[`registration[${key}]`] = registration[key]
      }
      body = this.$_apiMixin_addUtm(body, 'registration')

      return this.$_apiMixin_post('api/v2/register/', {
        client_secret: process.env.CLIENT_SECRET,
        ...body
      });
    },

    /**
     * Build a get request
     * @param uri
     * @param param
     * @param options
     * @returns {PromiseLike<T | never>}
     */
    $_apiMixin_get (uri, param = {}, options = {}) {
      options = Object.assign(this.$_apiMixin_httpBaseOptions(), options)

      return this.$http.get(this.$_apiMixin_getUrl(uri), { ...options, params: this.$_apiMixin_getParams(param) }, options)
        .then(response => {
          const frame = response.data

          if (!frame.hasOwnProperty("data")) return frame

          if (!frame.error) return frame.data

          this.$sentry.captureException(frame)
          throw frame.errno
        })
    },
    /**
     * Build a post request
     * @param uri
     * @param body
     * @param options
     * @returns {PromiseLike<HttpResponse | never>}
     */
    $_apiMixin_post (uri, body = {}, options = {}) {
      options = Object.assign(this.$_apiMixin_httpBaseOptions(), options)

      return this.$http.post(this.$_apiMixin_getUrl(uri), this.$_apiMixin_getBody(body), options)
        .then(response => {
          const frame = response.body
          if (frame.error) {
            this.$sentry.captureException(frame)
            throw frame.errno
          }
          return frame.data || frame
        })
    },
    /**
     * get the params of the request
     * @param params
     * @returns {*}
     */
    $_apiMixin_getParams (params) {
      params['client_id'] = process.env.CLIENT_ID
      return params
    },
    /**
     * parse the json body to a form data obejct
     * @param body
     * @returns {FormData}
     */
    $_apiMixin_getBody (body) {
      var form = new FormData()
      for (const key in body) {
        form.append(key, body[key])
      }
      form.append('client_id', process.env.CLIENT_ID)
      return form
    },
    $_apiMixin_getUrl (uri) {
      return `${process.env.API_URL}/${uri}`
    },
    $_apiMixin_addUtm(body, name) {
      if (Object.keys(this.utm).length > 0) {
        Object.entries(this.utm).forEach(it => {
          const key = `${name}[trackingData][${it[0]}]`
          body[key] = it[1]
        })
      }
      return body;
    },
    /**
     * Base options for HTTP requests used if not overridden
     * @returns {{timeout: number}}
     */
    $_apiMixin_httpBaseOptions () {
      return {
        timeout: 10000
      }
    }
  },
  computed: {
    ...mapState(['accessToken', 'utm']),
    /**
     * get the HTTP options for the request
     * @returns {{headers: {Authorization: string, 'x-app-version': string}, withCredentials: boolean}}
     */
    $_apiMixin_httpOptions () {
      return {
        headers: {
          'Authorization': `Bearer ${this.accessToken}`,
          'x-app-version': '10.0.0',
        },
        withCredentials: true,
      }
    }
  }
}
